import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import renderHTML from 'react-render-html';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, mensagens } from '../../../settings';
import { DelayLink } from '../../../components';

import '../Mensagem.scss';

class MensagemSuperintendencia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: mensagens[1],
      link: '/mensagens/presidencia',
      cor: 'yellow',
      outroProfissional: mensagens[0],
      width: window.innerWidth,
    };
    this.images = images;
    this.texts = texts;
    this.contentText = React.createRef();
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  render() {
    // <p>{renderHTML(profile.text)}</p>
    const { cor, profile, link, outroProfissional } = this.state;
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Mensagens - Relatório anual ANBIMA 2019 - {this.texts.title}</title>
        </Helmet>

        <div className="parallax-image mensagens-parallax">
          <img src={profile.bg} />
        </div>

        <div className="mensagens" ref="mensagens">
          <section className={`mensagens-area page--${cor}`}>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className={`card card--page-body card--${cor}`}>
                      <div className="card__content">
                        <div className="card__content__body">
                          <img src={profile.photo_grande} />
                          <h1 className={`title ${cor == 'blue' ? 'title-blue' : 'title-yellow'}`}>
                            Fala,
                            <br />
                            {profile.name}
                            <span className="gri_label">
                              GRI <b>102-14, 102-15</b>
                            </span>
                          </h1>
                          <p>mensagem da {profile.label.toLocaleLowerCase()}</p>
                          <div className="mensagem_text mensagem_text--yellow">
                            <p>{renderHTML(profile.text)}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className={`mensagens-area page--${cor}`}>
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className={`card card--page-body card--${cor == 'blue' ? 'yellow' : 'blue'}`}>
                      <div
                        className={`card__content card_content_links card_content_links-${
                          cor == 'blue' ? 'yellow' : 'blue'
                        }`}
                      >
                        <div>
                          <p>
                            Veja a mensagem do <br></br>
                            <span>nosso {outroProfissional.label_button.toLocaleLowerCase()}</span>
                          </p>
                        </div>
                        <div>
                          <DelayLink
                            to={link}
                            className={`button button--aylen button--${
                              cor == 'blue' ? 'yellow' : 'blue'
                            } button--border-medium button--size-m button--round-l button--text-thick`}
                          >
                            Ver mais
                          </DelayLink>
                          <div>
                            <img
                              className={`mensagens-area-foto mensagens-area-foto-${cor}`}
                              src={outroProfissional.photo}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="mensagens-area-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--blue box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-6">
                            <img src={images.mensagens.bg_rodape} className="pessoa_destaque pessoa_destaque--1" />
                          </div>
                          <div className="col col-6 col--text">
                            <h4>Saiba mais sobre quem somos</h4>
                            <DelayLink
                              to="/quem-somos"
                              className="button button--aylen button--white-to-blue button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Explorar
                            </DelayLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { MensagemSuperintendencia };
